<form [formGroup]="uploadDocumentForm">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-dialog
    [(visible)]="isDialogOpen"
    [closable]="false"
    [draggable]="false"
    [contentStyle]="{ 'max-height': '50em', width: 'auto' }"
    showEffect="fade"
    [modal]="false"
    styleClass="preview-modal"
    position="center">
    <ng-template #header>
      <div class="ui-g-11">
        <span>{{ selectedEngagementType }} Upload</span>
      </div>
      <div
        class="ui-g-1 closesidebar"
        (click)="closeDialog()"
        (keydown.enter)="closeDialog()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    @if (!hasError && !hasWarning && !validationSucces) {
      <div class="ui-g-12">
        <h3 class="ml-2 pl-1">Upload document</h3>
        <div class="ui-g-12">
          <h5 class="ml-2">Document type</h5>
          @if (isHybridWithCustomerList) {
            <div class="p-field-radiobutton mt-3">
              <p-radioButton
                name="userType"
                value="Customer"
                formControlName="userType"
                inputId="Customer">
              </p-radioButton>
              <label for="Customer" class="ml-2">Customer Document</label>
            </div>
          }
          @if (isHybridWithPartnerList) {
            <div class="p-field-radiobutton mt-3">
              <p-radioButton
                name="userType"
                value="Partner"
                formControlName="userType"
                inputId="Partner">
              </p-radioButton>
              <label for="Partner" class="ml-2">Partner Document</label>
            </div>
          }
        </div>
        <div class="display:flex; pt-3 mt-4">
          <div class="ui-g-12 pt-3 upload-btn">
            <button
              type="button"
              pButton
              [disabled]="!isDocumentTypeSelected()"
              (click)="openFilePicker(AccessListFileUpload)"
              class="flat btnmr fl-rt ui-state-default ui-button-info">
              Upload Document
            </button>
          </div>
        </div>
      </div>
    }
    <div class="upload-result-section">
      @if (hasWarning || hasError || validationSucces) {
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          @for (message of notificationMessage; track message) {
            <p-message [life]="3000" [text]="message.detail"></p-message>
          }
        </div>
      }
      @if (hasWarning) {
        <div class="ui-g-12 error-box">
          @if (duplicateMpnIDstoShow) {
            <div class="ui-g">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Duplicate MPN(s) numbers:
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ duplicateMpnIDstoShow }}
              </div>
            </div>
          }
          @if (vOrgIDstoShow) {
            <div class="ui-g">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are VOrg Id(s). Only location based PartnerIds are
                allowed:
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ vOrgIDstoShow }}
              </div>
            </div>
          }
          @if (invalidMpnIDstoShow) {
            <div class="ui-g margin-bottom">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Invalid PartnerId(s) numbers:
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ invalidMpnIDstoShow }}
              </div>
            </div>
          }
          @if (paidFacilitatorIDstoShow) {
            <div class="ui-g margin-bottom">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Paid Facilitator PartnerId(s) numbers:
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ paidFacilitatorIDstoShow }}
              </div>
            </div>
          }
          @if (duplicateTenantIDstoShow) {
            <div class="ui-g">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Duplicate Tenant ID(s):
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ duplicateTenantIDstoShow }}
              </div>
            </div>
          }
          @if (invalidTenantIDstoShow) {
            <div class="ui-g margin-bottom">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Invalid Tenant ID(s):
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ invalidTenantIDstoShow }}
              </div>
            </div>
          }
          @if (duplicateTPIDstoShow) {
            <div class="ui-g">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Duplicate TPID(s):
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ duplicateTPIDstoShow }}
              </div>
            </div>
          }
          @if (invalidTPIDstoShow) {
            <div class="ui-g">
              <div class="ui-g-4 ui-md-4 ui-lg-5">
                There are Invalid TPID(s):
              </div>
              <div class="ui-g-8 ui-md-8 ui-lg-7">
                {{ invalidTPIDstoShow }}
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="upload-result-section upload-button-section">
      <div class="ui-g-12 mt-3 pt-3">
        <div class="fl-rt">
          @if (hasWarning || hasError) {
            <button
              type="button"
              (click)="closeDialog()"
              pButton
              class="flat btnmr fl-rt cancel-button ui-button-info">
              Cancel
            </button>
          }
          @if (validationSucces) {
            <button
              type="button"
              (click)="closeDialog()"
              pButton
              class="flat btnmr fl-rt ui-state-default ui-button-info">
              Close
            </button>
          }
          @if (validationSucces || hasWarning) {
            <button
              type="button"
              (click)="uploadAccessListExcelFile()"
              pButton
              class="flat fl-rt ui-state-default ui-button-info">
              Continue
            </button>
          }
        </div>
      </div>
    </div>
    <input
      #AccessListFileUpload
      type="file"
      title=""
      style="display: none"
      (change)="validateAccessListExcelFile($event)"
      name="AccessListFileUpload"
      accept=".xlsm,.xlsx,.xls" />
  </p-dialog>
</form>
